"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash.omit")),
    _storage = require("./storage");

function deleteAssetFromLocalStorage(a) {
  var b = (0, _storage.getLocalStorage)();
  (0, _storage.setLocalStorage)((0, _lodash["default"])(b, [a]));
}

var _default = deleteAssetFromLocalStorage;
exports["default"] = _default;